module.exports = __webpack_public_path__ + "img/84.534da7d7.png";